<template>
	<div class="modal-card id_sheet_card">
		<header class="modal-card-head has-background-white">
			<h3 class="modal-card-title has-text-centered">
				Asignar el libro general(Clasificacion)
			</h3>
			<button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
		</header>
		<section class="modal-card-body id_sheet_body">
			<div class="columns">
				<div class="column is-8">
					<InputWithValidation id="idSheet" name="idSheet" label="Spreadsheet ID:" v-model="idSheet"
						rules="required" />
				</div>
			</div>
		</section>
		<footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
			<button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
				Volver
			</button>
			<button class="button is-primary" aria-label="Modificar Recurrencia" :disabled="loading || idSheet == ''"
				role="button" @click="saveNewIdSheet()">
				Grabar
			</button>
		</footer>
	</div>
</template>

<script>
import { updateGeneralBookSheetId } from "@/api/carteraAnalista";
import InputWithValidation from "@/components/inputs/InputWithValidation";
import { consoleHandlerError, notificate } from "@/utils/message";

export default {
	name: "IdSheetUpdate",
	data() {
		return {
			loading: false,
			idSheet: "",
		};
	},
	components: {
		InputWithValidation
	},
	methods: {
		saveNewIdSheet() {
			this.loading = true
			updateGeneralBookSheetId(this.idSheet, this.companyId).then(() => {
				notificate(
					`<strong>Éxito!</strong><br>
					Se actualizó el id del libro general`,
					"is-success is-light"
				);
				this.$emit("update-id-sheet", this.idSheet);
				this.$emit("close");
			}).catch(error => {
				consoleHandlerError({ error, empty: true });
				this.$emit("close");
			}).finally(() => {
				this.loading = false
			})
		},
	},
	props: ["companyId", "general_book_id_sheet"],
	created() {
		if (this.general_book_id_sheet) {
			this.idSheet = this.general_book_id_sheet
		}
	},
};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
.id_sheet_card {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
	width: min(540px, 94vw);
	display: flex;
	flex-direction: column;
	max-height: 86vh;
	background-color: var(--ap-paper);
	border-radius: var(--ap-radius);
	overflow: hidden;
}

:deep(.modal-card-title){
	font-family: var(--ap-font);
	font-weight: 700;
	font-size: 20px;
	letter-spacing: -0.01em;
	color: var(--ap-ink);
}

.modal-card-head {
	border-bottom: 1px solid var(--ap-line);
}

.id_sheet_body {
	background-color: var(--ap-paper);
	color: var(--ap-ink-2);
}

// Chrome del input (Buefy .input dentro de InputWithValidation compartido).
:deep(.input){
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	color: var(--ap-ink);
	box-shadow: none;
	transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

	&:focus,
	&:focus-visible {
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}
}

:deep(.label){
	color: var(--ap-slate);
	font-weight: 600;
	font-size: 13px;
}

:deep(.modal-card-foot){
	border-top: 1px solid var(--ap-line);

	.button.is-primary {
		background-color: var(--ap-ink);
		border-color: transparent;
		font-weight: 600;

		&:hover {
			background-color: var(--ap-teal-deep);
		}

		&:focus-visible {
			outline: 2px solid var(--ap-teal);
			outline-offset: 2px;
		}
	}
}
</style>
